import { render } from "./CouponsComponent.vue?vue&type=template&id=489c8829&scoped=true"
import script from "./CouponsComponent.vue?vue&type=script&lang=js"
export * from "./CouponsComponent.vue?vue&type=script&lang=js"

import "./CouponsComponent.vue?vue&type=style&index=0&id=489c8829&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c8829"]])

export default __exports__